<template>
    <div class="left-menu-bg">
        <div class="logo-text">数字人管理系统</div>
        <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" background-color="#00101F"
            text-color="#ccc" active-text-color="#fff" mode="vertical" unique-opened="true">
            <el-sub-menu index="1">
                <template #title>
                    <img src="../assets/shop.png" alt="" class="icon-img">
                    商城
                </template>
                <el-menu-item index="1-1" @click="toPage('/home', '1-1')">
                    <el-icon>
                        <edit />
                    </el-icon>
                    形象列表
                </el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="2">
                <template #title>
                    <img src="../assets/equipment.png" alt="" class="icon-img"></img>
                    设备管理
                </template>
                <el-menu-item index="2-1" @click="toPage('/equipmentList', '2-1')">
                    <el-icon>
                        <user />
                    </el-icon>
                    设备列表
                </el-menu-item>
            </el-sub-menu>
        </el-menu>
    </div>
</template>
<script>
import { reactive, toRefs, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router'
export default {
    setup() {
        const router = useRouter()
        const route = useRoute()
        const state = reactive({
            activeIndex: '1-1'
        })
        const mapIndexToPath = reactive(
            {
                '/': '1-1',
                '/home': '1-1',
                '/equipmentList': '2-1'
            }
        )
        const toPage = (path, index) => {
            sessionStorage.setItem('activeIndex', index)
            router.push({
                path: path
            })
        }
        onMounted(() => {
            const curActiveIndex = sessionStorage.getItem('activeIndex')
            const path = route.path
            const index = mapIndexToPath[path]
            state.activeIndex = curActiveIndex ? curActiveIndex : index
        })
        return {
            ...toRefs(state),
            toPage
        }
    }
}
</script>
<style scoped lang="less">
.left-menu-bg {
    width: 200px;
    height: 100vh;
    background-color: #00101F;

    .icon-img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
    }

    .logo {
        width: 50px;
        display: inline-block;
        margin-top: 16px;
        margin-left: 10px;
    }

    .logo-text {
        margin-left: 10px;
        color: #fff;
        vertical-align: top;
        padding-top: 15px;
        text-align: center;
        font-size: 18px;
    }

    .el-sub-menu .el-menu-item {
        height: 40px;
    }

    .el-menu-item.is-active {
        background-color: #1979FE;
    }
}
</style>